import React, { useState, useRef } from 'react';
import { FormControl, IconButton } from '@material-ui/core';
import { Close, Done } from '@material-ui/icons';
import { isNull } from 'util';
import { KEY_CODES } from '@app/pages/ssoManager/addEditApplication.enums';
import { useTypedTranslation } from '@app/hooks';
import { PasslyTextField } from '@app/components';

interface IAudienceUriComponentState {
    prevValue: string;
    value: string;
    edit: boolean;
}

interface IProps {
    audienceUri: string;
    index: number;
    onRemove?: () => void;
    onSave?: (value: string) => void;
}

export const AudienceUriListItemComponent: React.SFC<IProps> = ({
    audienceUri,
    index,
    onRemove,
    onSave
}: IProps) => {

    const { translation } = useTypedTranslation();

    const [{ value, edit }, setState] = useState<IAudienceUriComponentState>({
        prevValue: audienceUri,
        value: audienceUri,
        edit: false
    });

    let textInput = useRef<HTMLInputElement>(null);

    // FUNCTIONS
    const handleSaveUri = () => {
        if (onSave) {
            onSave(value);
            setState(prevState => ({ ...prevState, edit: false }));
        }
    };

    const handleRemoveUri = () => {
        if (onRemove) onRemove();
    };

    const toggleEdit = (edit: boolean) => {
        setState(prevState => ({ ...prevState, edit }));
        if (edit) {
            focusTextInput();
        } else {
            resetValue(edit);
        }
    };

    const resetValue = (isEdditing: boolean) => {
        setState(prevState => ({ ...prevState, edit: isEdditing, value: prevState.prevValue }));
    };

    const focusTextInput = () => {
        if (!isNull(textInput.current)) textInput.current.focus();
    };

    const handleTextInputChange = ({
        target: { value }
    }: React.ChangeEvent<HTMLInputElement>) => {
        setState(prevState => ({ ...prevState, value }));
    };

    const handleKeyPress = ({keyCode}: React.KeyboardEvent<HTMLInputElement>) => {
        if (keyCode === KEY_CODES.enter) handleSaveUri();
        if (keyCode === KEY_CODES.escape) toggleEdit(false);
    };
    const audienceUriEdit = () => toggleEdit(true);

    return (
        <>
            <FormControl>
                <PasslyTextField
                    name={`audienceUri-${index}`}
                    value={value}
                    id={`audienceUri-input-${index}`}
                    readOnly={!edit}
                    onChange={handleTextInputChange}
                    inputRef={textInput}
                    onKeyDown={handleKeyPress}
                    onEditButtonClick={!edit ? audienceUriEdit : undefined}
                    onDeleteButtonClick={handleRemoveUri}
                    fullWidth
                />
                {/* EDIT */}
                {edit && (
                    <div className='audienceuri-list__input__actions'>
                        {/* URI ACTIONS */}
                        {/* CANCEL */}
                        <IconButton
                            aria-label={translation('CANCEL')}
                            size='small'
                            id={`audienceUri-input-edit-cancel-${index}`}
                            onClick={() => toggleEdit(false)}
                        >
                            <Close />
                        </IconButton>
                        {/* SAVE */}
                        <IconButton
                            aria-label={translation('SAVE_CHANGES')}
                            size='small'
                            color='primary'
                            id={`audienceUri-input-edit-approve-${index}`}
                            onClick={() => handleSaveUri()}
                        >
                            <Done />
                        </IconButton>
                    </div>
                )}
            </FormControl>
        </>
    );
};
